
<NConfirm variant="alert" :title="title" @close="$emit('close')" @confirm="$emit('confirm')"><slot /></NConfirm>
